export enum PRODUCT_TYPES {
	tuition = 1,
	loan = 2,
	expertGuidance = 3,
	educationPathways = 4,
	customPathway = 999 // Can be revisited; this is added as an interim solution to support a custom pathway experience for NYP
}
